"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSlotListPosition = getSlotListPosition;
function getSlotListPosition(slotPosition, slotCount) {
  if (slotCount === 1 || slotPosition === 0) {
    return 'top';
  }
  if (slotPosition === slotCount - 1) {
    return 'bottom';
  }
  return 'middle';
}
//# sourceMappingURL=getSlotListPosition.js.map